<template>
    <div class="input-organization">
        <div v-if="busy" class="overlay">
            <loader-inline />
        </div>
        <div v-if="edit" class="edit-container">
            <input type="text" placeholder="write here..." ref="input" :value="originalValue" @keyup.enter="update" />
            <a
                @click="update"
                class="text-success"
                v-tooltip="$t('form.button.confirm')"
            >
                <i class="fas fa-check"></i>
            </a>
            <a
                @click="cancel"
                class="text-danger"
                v-tooltip="$t('form.button.cancel')"
            >
                <i class="fas fa-times"></i>
            </a>
        </div>
        <a v-else class="text-container" @click="toggleEdit">
            <p v-text="originalValue"></p>
            <a
                class="edit text-info"
                v-tooltip="$t('form.button.edit')"
            >
                <i class="icon far fa-edit"></i>
            </a>
            <a
                @click.prevent="remove"
                class="remove text-danger"
                v-tooltip="$t('form.button.remove')"
            >
                <i class="fas fa-trash"></i>
            </a>
        </a>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import LoaderInline from "../../loader-inline";

export default {
    props: {
        id: [Number, String],
        value: {
            type: String
        },
        tagId: {
            type: Number
        }
    },
    components: {
        LoaderInline
    },
    data: function() {
        return {
            originalValue: this.originalValue || this.value || "",
            edit: false,
            busy: false
        };
    },
    updated: function() {
        // When edit is set to true, then system will render
        // input. AFTER that (hence the use of this), we can
        // call for input.focus()...
        this.$nextTick(function() {
            if (this.edit && this.$refs && this.$refs.input) {
                this.$refs.input.focus();
            }
        }.bind(this));
    },
    methods: {
        ...mapActions("organizations", ["updateOrganization", "deleteOrganization"]),
        toggleEdit: function() {
            this.edit = !this.edit;
        },
        update: function() {
            const value = this.$refs.input.value;
            this.$emit("input", value);
            this.edit = !this.edit;

            if (value && this.originalValue != value) {
                this.busy = true;

                this.updateOrganization({
                    projectId: this.$route.params.project_uid,
                    organization: {
                        id: this.id,
                        name: value,
                        parent_tag_id: this.tagId
                    }
                }).finally(function() {
                    this.busy = false;
                    this.$emit("update");
                    this.originalValue = value;
                }.bind(this));
            }
        },
        remove: function() {
            this.busy = true;
            this.deleteOrganization({
                projectId: this.$route.params.project_uid,
                organizationId: this.id
            }).finally(function(){
                this.busy = false;
            }.bind(this));
        },
        cancel: function() {
            this.value = this.originalValue;
            this.edit = !this.edit;
        }
    }
}
</script>

<style lang="scss">
$background: #f5f5f5;

.input-organization {
    position: relative;
    border-radius: 2px;

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: $background;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
    }

    .edit-container {
        display: flex;
        height: 28px;

        input {
            outline: 0;
            flex: 1;
            border: 0;
            border-bottom: 1px solid #CCC;
            padding-left: 5px;
            padding-right: 5px;
            background: transparent !important;
            margin-bottom: 0px;
            margin-right: 0px;
        }

        a {
            cursor: pointer;
            line-height: 27px;
            border-bottom: 1px solid #CCC;
            display: inline-block;
            width: 18px;
            text-align: center;
            margin-bottom: 0px;
            margin-right: 0px;
        }
    }

    .text-container {
        display: flex;
        cursor: pointer;
        background: $background;
        padding: 2px 5px;

        p {
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 0;
            line-height: 28px;
            flex: 1;
        }

        a {
            display: block;
            padding: 0 5px;
            line-height: 28px;
            opacity: 0;
            transition: opacity .5s;
        }

        &:hover a {
            opacity: 1;
        }
    }
}
</style>